import { isTemplatePlaceholder } from '@/types';
import { RuleProperties } from '@react-awesome-query-builder/mui';
import { StatisticalArea1Filter } from '@/types/searchFilterTypes';
import { FilterMapper } from './filterMapperTypes';

export const Sa1Mapper: FilterMapper = {
  checkIsIncomplete({ value }) {
    const isNoTagSelected = value[0].value.length === 0;
    return isNoTagSelected;
  },

  toFilter({ value }: RuleProperties): StatisticalArea1Filter {
    if (!value) throw new Error('Missing value');

    if (value.length !== 1) throw new Error('Invalid value. Expected array of length 1');

    if (isTemplatePlaceholder(value[0].value)) {
      return { name: 'sa1', value: value[0].value };
    }

    const sa1s = value[0] as { value: string };
    if (sa1s.value === '') {
      return { name: 'sa1', value: [] } as StatisticalArea1Filter;
    }

    const sa1Ids = sa1s.value.split(',').map((sa1) => {
      const parsedNumber = parseInt(sa1);
      if (isNaN(parsedNumber)) throw new Error();
      return parsedNumber;
    });

    return { name: 'sa1', value: sa1Ids } as StatisticalArea1Filter;
  },

  async fromFilter(filter: StatisticalArea1Filter) {
    if (isTemplatePlaceholder(filter.value)) {
      return {
        field: filter.name,
        operator: 'is one of',
        value: [
          {
            value: filter.value,
            errors: [],
          },
        ],
      };
    }
    return {
      field: filter.name,
      operator: 'is one of',
      value: [{ value: filter.value.join(', '), errors: [] }],
    };
  },
};
